import React, { useState, useEffect } from "react";
import { Box} from "@mui/material";
import Layout from "../../components/Layout";
import ReviewModerationPanel from "./ReviewModerationPanel";
import ServiceReviewModerationPanel from "./veterinarianServiceReview";

type RatingItem = {
    id: string;
    name: string;
    rating: number;
    review: string;
};

type TabKey = 'product' | 'service' | 'appointment';


export default function Reviewmain() {
    const [activeTab, setActiveTab] = useState<TabKey>('product');
    const [loading, setLoading] = useState(true);
    const [productRatings, setProductRatings] = useState([]);
    const [serviceRatings, setServiceRatings] = useState([]);
    const [appointmentRatings, setAppointmentRatings] = useState([]);



    const buttonStyle = (tab: TabKey, bgColor: string, shadowColor: string) => ({
        boxShadow: activeTab === tab
            ? `0 4px 10px ${shadowColor}, inset 0 2px 0 rgba(255,255,255,0.3)`
            : `0 2px 6px rgba(156,163,175,0.4), inset 0 1px 0 rgba(255,255,255,0.2)`,
        backgroundColor: activeTab === tab ? bgColor : "#9CA3AF",
        color: activeTab === tab ? "#fff" : "#111827",
        padding: "0.5rem 1rem",
        borderRadius: "1rem",
        fontWeight: 500,
        transition: "all 0.2s",
    });

    return (
        <Layout>
            <Box sx={{ p: 2 }}>
                {/* Custom Buttons */}
                <Box className="flex gap-4 mb-6" sx={{ display: "flex", gap: 2, mb: 6 }}>
                    <button onClick={() => setActiveTab('product')} style={buttonStyle('product', '#EF4444', 'rgba(239,68,68,0.6)')}>Products</button>
                    <button onClick={() => setActiveTab('service')} style={buttonStyle('service', '#22C55E', 'rgba(34,197,94,0.6)')}>Veterinarian & Service</button>
                </Box>

                {/* Ratings */}
                <Box>
                    {activeTab === 'product' && <ReviewModerationPanel />}
                    {activeTab === 'service' && <ServiceReviewModerationPanel />}
                </Box>
            </Box>
        </Layout>
    );
}
